const theme = {
  colors: {
    primary: "#3B8BEB",
    grey: "#8590AA",
    accent: "#C4DBF6",
    secondary: "#EB5160",
    teritiary: "#27ae60",
  },
  fonts: {
    main: `'Fira Sans', sans-serif`,
  },
  layout: {
    navHeight: "5rem",
  },
};

export default theme;
